<template>
  <form
    :class="['row filtros mx-0', {'justify-content-sm-center justify-content-lg-start': estadoSeleccionado && !municipioSeleccionado.length}]"
    @submit.prevent
  >
    <!-- Estados -->
    <div class="col-12 col-sm-6 col-lg-4" v-if="Object.keys(estados).length">
      <v-select
        v-model="estadosAFiltrar"
        :searchable="false"
        :options="Object.values(estados)"
        :getOptionLabel="estados => estados.est_zon"
        multiple
        class="outline-datalist my-2"
        small-text="Haz clic en el botón > del estado para ver sus municipios"
        @input="municipios={};municipioSeleccionado = [];estadoSeleccionado = [];municipiosAFiltrar=[];parroquiasAFiltrar=[];$emit('zonasAFiltrar', {estados: estadosAFiltrar, municipios: [], parroquias: []});"
      >
        <template #header>
          <label :class="['datalist-label', {'activo': estadosAFiltrar && Object.keys(estadosAFiltrar).length}]">
            Estado(s)
          </label>
        </template>
        <template #option="estados">
          <div class="row-flex">
            <p>{{ estados.est_zon }}</p>
            <mdb-btn
              flat
              dark-waves
              icon="angle-right"
              type="button"
              class="m-0 py-1 px-3"
              :title="`Seleccionar municipio/s del estado ${estados.est_zon}`"
              @click="seleccionarMunicipios(estados)"
            />
          </div>
        </template>
      </v-select>
    </div>
    <!-- Transportistas -->
    <div class="col-12 col-sm-6 col-lg-4"
      v-if="Object.keys(transportistasObj).length">
      <v-select v-model="transportista" :searchable="false" :options="Object.values(transportistasObj)"
        :getOptionLabel="transportistasObj => transportistasObj.nom_per" multiple class="outline-datalist my-2"
        @input="transportistasEnvio">
        <template #header>
          <label :class="['datalist-label', { 'activo': transportista.includes(transportistasObj.id_per) }]">
            Transportistas
          </label>
        </template>
        <template #option="transportistasObj">
          {{ transportistasObj.nom_per }} {{ transportistasObj.ape_per }}
        </template>
      </v-select>
    </div>
    <div v-if="mes" class="col-12 col-sm-6 col-lg-4">
      <mdb-input v-model="mesAFiltrar" type="month" label="Mes" class="my-2" outline />
    </div>
    <div v-if="fechaDesde" class="col-12 col-sm-6 col-lg-4">
      <mdb-input v-model="fechaDesdeAFiltrar" type="date" label="Desde" class="my-2" outline />
    </div>
    <div v-if="fechaHasta" class="col-12 col-sm-6 col-lg-4">
      <mdb-input v-model="fechaHastaAFiltrar" type="date" label="Hasta" class="my-2" outline />
    </div>
    <div
      v-if="estadoSeleccionado.length"
      class="col-12 col-sm-6 col-lg-4"
    >
      <v-select
        v-model="municipiosAFiltrar"
        :searchable="false"
        :options="Object.values(municipios)"
        :getOptionLabel="municipios => municipios.ciu_zon"
        multiple
        class="outline-datalist my-2"
        small-text="Haz clic en el botón > del municipio para ver sus parroquias"
        @input="$emit('zonasAFiltrar', {estados: estadoSeleccionado, municipios: municipiosAFiltrar, parroquias: []}); municipioSeleccionado = []"
      >
        <template #header>
          <label :class="['datalist-label', {'activo': municipiosAFiltrar && Object.values(municipiosAFiltrar).length}]">
            Municipio(s)
          </label>
        </template>
        <template #option="municipios">
          <div class="row-flex">
            <p>{{ municipios.ciu_zon }}</p>
            <mdb-btn
              flat
              dark-waves
              icon="angle-right"
              type="button"
              class="m-0 py-1 px-3"
              :title="`Seleccionar parroquia/s del municipio ${municipios.ciu_zon}`"
              @click="seleccionarParroquias(municipios)"
            />
          </div>
        </template>
      </v-select>
    </div>
    <!-- Parroquias -->
    <div
      v-if="municipioSeleccionado.length"
      class="col-12 col-sm-6 col-lg-4"
    >
      <v-select
        v-model="parroquiasAFiltrar"
        :searchable="false"
        :options="Object.values(parroquias)"
        :getOptionLabel="parroquias => parroquias.sec_zon"
        multiple
        class="outline-datalist my-2"
        @input="$emit('zonasAFiltrar', {estados: estadoSeleccionado, municipios: municipioSeleccionado, parroquias: parroquiasAFiltrar});"
      >
        <template #header>
          <label :class="['datalist-label', {'activo': parroquiasAFiltrar && Object.values(parroquiasAFiltrar).length}]">
            Parroquia(s)
          </label>
        </template>
        <template #option="parroquias">
          {{ parroquias.sec_zon }}
        </template>
      </v-select>
    </div>
    <!-- Tipos de clientes -->
    <div class="col-12 col-sm-6 col-lg-4" v-if="Object.keys(tipos).length">
      <v-select
        v-model="tiposCliente"
        :searchable="false"
        :options="Object.values(tipos)"
        :getOptionLabel="tipos => tipos.nom_tcl"
        multiple
        class="outline-datalist my-2"
        @input="tiposCliEnvio"
      >
        <template #header>
          <label :class="['datalist-label', {'activo':tiposCliente.includes(tipos.id_tcl)}]">
            Tipos de cliente
          </label>
        </template>
        <template #option="tipos">
          {{tipos.nom_tcl}}
        </template>
      </v-select>
    </div>
    <!-- Morosidad -->
    <div class="col-12 col-sm-6 col-lg-4" v-if="estatusFactura && EstatusFactura.length">
      <v-select
        v-model="factura"
        :searchable="false"
        :options="EstatusFactura"
        :getOptionLabel="EstatusFactura => EstatusFactura.nombre"
        multiple
        class="outline-datalist my-2"
        @input="facturaEnvio"
      >
        <template #header>
          <label :class="['datalist-label', {'activo': factura.includes(EstatusFactura.nombre)}]">
            Estatus de factura
          </label>
        </template>
        <template #option="EstatusFactura">
          {{EstatusFactura.nombre}}
        </template>
      </v-select>
    </div>
    <div
      v-if="nombre"
      class="col-12 col-sm-6 col-lg-4"
    >
      <mdb-input
        v-model="nombreAFiltrar"
        label="Nombre del cliente"
        class="my-2"
        outline
        @input="$emit('nombreAFiltrar', nombreAFiltrar);"
      />
    </div>
    <div
      v-if="fecha"
      class="col-12 col-sm-6 col-lg-4"
    >
      <mdb-input
        v-model="fechaAFiltrar"
        type="date"
        label="Fecha"
        class="my-2"
        outline
        @input="$emit('fechaAFiltrar', fechaAFiltrar);"
      />
    </div>
    <div :class="[responsive.year ? responsive.year : 'col-12 col-sm-6 col-lg-4']" v-if="year">
      <mdb-input v-model="fechaAno" type="number" label="Año" class="my-2" outline :min="2000" :max="2040"
        @input="$emit('anoAFiltrar', fechaAno)" />
    </div>
    <div
      v-if="cliPotenciales"
      class="col-6 col-lg-auto px-0 text-center align-self-center"
    >
      <div class="btn-checkgroup-contenedor mt-2">
        <input
          v-model="clientesPotenciales"
          id="clientesPo"
          type="checkbox"
          name="checkbox-categoria"
          @click="clientesPotenciales = !clientesPotenciales; clientesPotencialesEnvio()"
          >
        <label for="clientesPo" class="btn-checkgroup my-1 icon-target-account">
          Potenciales
        </label>
      </div>
    </div>
    <!-- Estatus cliente -->
    <div class="col-12 col-sm-6 col-lg-4" v-if="estCliente">
      <v-select
        v-model="estatusCliente"
        :searchable="false"
        :options="statusCli"
        :getOptionLabel="statusCli => statusCli.status"
        :getOptionValue="statusCli => statusCli.id"
        :clearable="false"
        class="outline-datalist my-2"
        @input="filtroEstatus"
      >
        <template #header>
          <label :class="['datalist-label', {'activo': estatusCliente === statusCli.id}]">
            Estatus de cliente
          </label>
        </template>
        <template #option="EstatusCliente">
          {{EstatusCliente.status}}
        </template>
      </v-select>
    </div>
    <div :class="[responsive.vendedor ? responsive.vendedor : 'col-12 col-sm-6 col-lg-4']"
      v-if="Object.keys(vendedores).length">
      <v-select v-model="vendedor" :searchable="false" :options="Object.values(vendedores)"
        :getOptionLabel="vendedores => vendedores.nom_per" multiple class="outline-datalist my-2"
        @input="vendedoresEnvio">
        <template #header>
          <label :class="['datalist-label', { 'activo': vendedor.includes(vendedores.id_ven) }]">
            Vendedores
          </label>
        </template>
        <template #option="vendedores">
          {{ vendedores.nom_per }} {{ vendedores.ape_per }}
        </template>
      </v-select>
    </div>
    <div
      v-if="cliPlanificaciones"
      class="col px-0 text-center align-self-center"
    >
      <div class="btn-checkgroup-contenedor mt-2">
        <input
          v-model="clientesPlanificaciones"
          id="clientesPla"
          type="checkbox"
          name="checkbox-categoria"
          @click="clientesPlanificaciones = !clientesPlanificaciones; clientesPlanificacionesEnvio()"
          >
        <label for="clientesPla" class="btn-checkgroup my-1 py-2 icon-calendar-xmark">
          Sin planificación
        </label>
      </div>
    </div>
    <div v-if="mostrarBtnRestablecer" class="col-12 col-sm text-center">
      <mdb-btn
        flat
        dark-waves
        icon="broom"
        class="my-1 px-3"
        @click="$emit('eliminarFiltros'); eliminarFiltrosSeleccionados()"
      >
        Restablecer filtros
      </mdb-btn>
    </div>
  </form>
</template>

<script>
import {mdbBtn, mdbInput} from 'mdbvue';
import {EstatusFactura} from '@/constantes/facturas.js';
import {statusCli} from '@/constantes/estatusCliente.js';
export default {
  name: 'FiltrosTipo1',
  components: {
    mdbBtn,
    mdbInput,
  },
  props: {
    ven: {
      type: Array,
      default: () => [],
    },
    year: {
      type: Boolean,
      default: false,
    },
    zonas: {
      type: Array,
      default: () => [],
    },
    tiposCli: {
      type: Array,
      default: () => [],
    },
    transportistas: {
      type: Array,
      default: () => [],
    },
    nombre: {
      type: Boolean,
      default: true,
    },
    fecha: {
      type: Boolean,
      default: true,
    },
    mes: {
      type: Boolean,
      default: false,
    },
    fechaDesde: {
      type: Boolean,
      default: false,
    },
    fechaHasta: {
      type: Boolean,
      default: false,
    },
    mesPorDefecto: {
      type: String,
      default: '',
    },
    limpiarFechas: {
      type: Number,
      default: 0,
    },
    cliPotenciales: {
      type: Boolean,
      default: false,
    },
    estCliente: {
      type: Boolean,
      default: false,
    },
    estatusFactura: {
      type: Boolean,
      default: true,
    },
    cliPlanificaciones: {
      type: Boolean,
      default: false,
    },
    restablecerFiltrado: {
      type: Boolean,
      default: false,
      required: false,
    },
    mostrarBtnRestablecer: {
      type: Boolean,
      default: true,
      required: false,
    },
    responsive: {
      type: Object,
      default: function() {
        return {
          vendedor: '',
          btnRestablecer: '',
        };
      },
    },
  },
  data() {
    return {
      isResetting: false,
      transportistaAFiltrar: [],
      tiposAFiltrar: [],
      nombreAFiltrar: '',
      mesAFiltrar: '',
      fechaDesdeAFiltrar: '',
      fechaHastaAFiltrar: '',
      fechaAFiltrar: '',
      estadosAFiltrar: [],
      municipiosAFiltrar: [],
      parroquiasAFiltrar: [],
      estadoSeleccionado: [],
      municipioSeleccionado: [],
      municipios: {},
      parroquias: {},
      transportista: [],
      tiposCliente: [],
      EstatusFactura,
      statusCli,
      factura: [],
      facturaFiltrar: [],
      clientesPotenciales: false,
      clientesPlanificaciones: false,
      estatusCliente: {
        id: null,
        status: 'Activos',
      },
      vendedorAFiltrar: [],
      vendedor: [],
      fechaAno: (new Date().getFullYear()).toString(),
    };
  },
  created() {
    if (this.mesPorDefecto) {
      this.isResetting = true;
      this.mesAFiltrar = this.mesPorDefecto;
      this.$nextTick(() => {
        this.isResetting = false;
      });
    }
  },
  methods: {
    vendedoresEnvio() {
      this.vendedorAFiltrar = [];
      this.vendedor.forEach((v) => {
        this.vendedorAFiltrar.push(v.id_per_ven);
      });
      this.$emit('vendedorAFiltrar', this.vendedorAFiltrar);
    },
    seleccionarMunicipios(estado) {
      this.estadosAFiltrar = [];
      this.estadosAFiltrar.push(estado);
      this.municipioSeleccionado = [];
      this.estadoSeleccionado.push(estado);
      this.municipios = estado.municipios;
      this.municipiosAFiltrar = [];
      this.parroquiasAFiltrar = [];
      this.$emit('zonasAFiltrar', {estados: this.estadosAFiltrar, municipios: [], parroquias: []});
    },
    seleccionarParroquias(municipio) {
      this.municipiosAFiltrar = [];
      this.municipiosAFiltrar.push(municipio);
      this.municipioSeleccionado.push(municipio);
      this.parroquias = municipio.parroquias;
      this.parroquiasAFiltrar = [];
      this.$emit('zonasAFiltrar', {estados: this.estadosAFiltrar, municipios: this.municipiosAFiltrar, parroquias: []});
    },
    tiposCliEnvio() {
      this.tiposAFiltrar = [];
      this.tiposCliente.forEach((t) => {
        this.tiposAFiltrar.push(t.id_tcl);
      });
      this.$emit('tiposAFiltrar', this.tiposAFiltrar);
    },
    facturaEnvio() {
      this.facturaFiltrar = [];
      this.factura.forEach((factura) => {
        this.facturaFiltrar.push(factura.nombre);
      });
      this.$emit('estatusFacturaAFiltrar', this.facturaFiltrar);
    },
    clientesPotencialesEnvio() {
      this.$emit('clientesPo', this.clientesPotenciales);
    },
    clientesPlanificacionesEnvio() {
      this.$emit('clientesPla', this.clientesPlanificaciones);
    },
    filtroEstatus() {
      this.$emit('filtroEstatus', this.estatusCliente.id);
    },
    transportistasEnvio() {
      const ids = this.transportista.map((t) => t.id_per);
      this.$emit('transportistaAFiltrar', ids);
    },
    eliminarFiltrosSeleccionados() {
      this.isResetting = true;
      this.tiposAFiltrar = [];
      this.nombreAFiltrar = '';
      this.fechaAFiltrar = '';
      this.estadosAFiltrar = [];
      this.municipiosAFiltrar = [];
      this.parroquiasAFiltrar = [];
      this.estadoSeleccionado = [];
      this.municipioSeleccionado = [];
      this.municipios = {};
      this.parroquias = {};
      this.tiposCliente = [];
      this.transportista = [];
      this.estatusCliente = {
        id: null,
        status: 'Activos',
      };
      this.fechaDesdeAFiltrar = '';
      this.fechaHastaAFiltrar = '';
      if (this.mesPorDefecto) {
        this.mesAFiltrar = this.mesPorDefecto;
      } else {
        this.mesAFiltrar = '';
      }
      this.$nextTick(() => {
        this.isResetting = false;
      });
      this.fechaAno = (new Date().getFullYear()).toString();
    },
  },
  watch: {
    mesAFiltrar(val) {
      if (this.isResetting) return;
      this.$emit('mesAFiltrar', val);
    },
    fechaDesdeAFiltrar(val) {
      if (this.isResetting) return;
      this.$emit('fechaDesdeAFiltrar', val);
    },
    fechaHastaAFiltrar(val) {
      if (this.isResetting) return;
      this.$emit('fechaHastaAFiltrar', val);
    },
    limpiarFechas() {
      this.isResetting = true;
      this.fechaDesdeAFiltrar = '';
      this.fechaHastaAFiltrar = '';
      if (this.mesPorDefecto) {
        this.mesAFiltrar = this.mesPorDefecto;
      } else {
        this.mesAFiltrar = '';
      }
      this.$nextTick(() => {
        this.isResetting = false;
      });
    },
    restablecerFiltrado() {
      this.eliminarFiltrosSeleccionados();
    },
  },
  computed: {
    vendedores() {
      const vendedores = {};
      this.ven.forEach((e) => {
        if (!vendedores[e.id_ven]) {
          vendedores[e.id_ven] = {
            id_ven: e.id_ven,
            nom_per: e.nom_per,
            ape_per: e.ape_per,
            id_per_ven: e.id_per,
          };
        }
      });
      return vendedores;
    },
    estados() {
      const estados = {};
      this.zonas.forEach((e) => {
        if (!estados[e.est_zon]) {
          estados[e.est_zon] = {
            est_zon: e.est_zon,
            municipios: [],
          };
        }
        if (!estados[e.est_zon].municipios[e.ciu_zon]) {
          estados[e.est_zon].municipios[e.ciu_zon] = {
            ciu_zon: e.ciu_zon,
            parroquias: [],
          };
        }
        if (!estados[e.est_zon].municipios[e.ciu_zon].parroquias[e.sec_zon]) {
          estados[e.est_zon].municipios[e.ciu_zon].parroquias[e.sec_zon] = {
            sec_zon: e.sec_zon,
          };
        }
      });
      return estados;
    },
    tipos() {
      const tipos = {};
      this.tiposCli.forEach((e) => {
        if (!tipos[e.id_tcl]) {
          tipos[e.id_tcl] = {
            id_tcl: e.id_tcl,
            nom_tcl: e.nom_tcl,
          };
        }
      });
      return tipos;
    },
    transportistasObj() {
      const tra = {};
      this.transportistas.forEach((e) => {
        if (!tra[e.id_per]) {
          tra[e.id_per] = {
            id_per: e.id_per,
            nom_per: e.nom_per + ' ' + e.ape_per,
          };
        }
      });
      return tra;
    },
    nombresDeTiposAFiltrar() {
      const nombres = [];
      this.tiposAFiltrar.forEach((tipo) => {
        nombres.push(this.tipos[tipo].nom_tcl);
      });
      return nombres;
    },
  },
};
</script>

<style lang="scss" scoped>
.row-flex {
  align-items: center;
  display: flex;
  flex-flow: row nowrap;

  p {
    flex-grow: 2;
    margin-bottom: 0;
  }
}
</style>
